export default class CreateParticipationCtrl {

  constructor ($scope, $timeout, $mdDialog, $stateParams, $cookies, WorkPlanSrv, GlobalConfig, $state, WorkPlanModalSrv, GlobalSrv) {
    var participationVm = this
    const texts = GlobalConfig.appTexts
    participationVm.isEditing = Boolean($stateParams.workplanTeacherActivityId)
    participationVm.createOrEdit = ''
    participationVm.start_date = null
    participationVm.end_date = null
    participationVm.minStartDate = moment().toDate()
    participationVm.minEndDate = new Date()
    participationVm.actionEditOrCreate = 'creado'
    participationVm.createdOrEdit = 'Creación'
    participationVm.createdOrEditParticipation = 'Crear'
    participationVm.textCreateOrEdit = texts.saved
    participationVm.createOrEditMV = texts.createDialog
    participationVm.rangeType = 1
    participationVm.range = GlobalConfig.periods.rangeType
    participationVm.periodsArray = []
    participationVm.listCommitteeCombo = []
    participationVm.selectedTypePeriod = {}
    participationVm.isTouchedPeriods = false
    participationVm.detail = ''
    participationVm.typeUnit = 1
    participationVm.listPeriods = []
    participationVm.periodArray = []
    participationVm.minStartDate = new Date()
    participationVm.plannedHours = ''
    participationVm.hoursPlanned = 0
    participationVm.dt_start = $cookies.get('wp_start')
    participationVm.dt_end = $cookies.get('wp_end')

    const listUser = JSON.parse($cookies.get('currentUser'))

    participationVm.isFeedback = listUser.isFeedback

    participationVm.updateRangeType = (val) => {
      participationVm.rangeType = val
      participationVm.periodsArray = []
      participationVm.startDate = null
      participationVm.endDate = null
    }
    participationVm.updateRangeData = (val) => {
      participationVm.periodsArray = val['periods']
      participationVm.start_date = val['dates'][0]
      participationVm.end_date = val['dates'][1]
    }
    
    const header = {
      teacherId: listUser.teacherId,
      workplanId: listUser.workplanId,
      workplanTeacherActivityId: $stateParams.workplanTeacherActivityId,
      name: listUser.name
    }
    participationVm.addParticipation = addParticipation
    participationVm.validateForm = validateForm
    participationVm.funSelectedPeriod = funSelectedPeriod
    participationVm.confirmParticipationAction = confirmParticipationAction
    participationVm.isPeriodEmpty = isPeriodEmpty
    participationVm.hasError = hasError
    participationVm.showErrorMessages = showErrorMessages
    participationVm.validateCheklistPeriods = validateCheklistPeriods
    participationVm.startDateChange = startDateChange
    participationVm.close = close

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function validateForm (form) {
      return form.$invalid || participationVm.validateCheklistPeriods()
    }

    function validateCheklistPeriods () {
      return (participationVm.rangeType == participationVm.range ? participationVm.periodsArray.length < 1 : false)
    }

    function getDataFormCommittee () {
      // List Service Committee
      return WorkPlanSrv.getDataFormCommittee.get(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          participationVm.listCommitteeCombo = dataReturn.listCommittee.items
          participationVm.listPeriods = dataReturn.listPeriods
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function getActivityCommitteeByActivity () {
      // Edit Committee
      WorkPlanSrv.getActivityCommitteeByActivity.get(header)
      .$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          setValues(dataReturn.data[0])
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    activate()

    function activate () {
      getDataFormCommittee().then(function () {
        if (participationVm.isEditing) {
          participationVm.createdOrEdit = 'Edición'
          participationVm.createdOrEditParticipation = 'Editar'
          participationVm.actionEditOrCreate = 'modificado'
          participationVm.createOrEditMV = texts.editDialog
          participationVm.textCreateOrEdit = texts.modified
          getActivityCommitteeByActivity()
        }
      })
    }

    function setValues (committee) {
      let selectedElement = {
        idListItem: committee.comiteeId,
        listItemName: committee.comiteeName,
        isRequired: 0
      }
      participationVm.listCommitteeCombo.push(selectedElement)
      participationVm.committeeName = committee.comiteeId
      participationVm.hoursPlanned = committee.hoursPlanned
      participationVm.detail = committee.description
      participationVm.rangeType = committee.timeRangeTypeId

      participationVm.start_date = moment(committee.startDate, 'YYYY-MM-DD').toDate()
      participationVm.end_date = moment(committee.endDate, 'YYYY-MM-DD').toDate()

      participationVm.periodsArray = []
      participationVm.selectedTypePeriod = {}

      if (parseInt(committee.timeRangeTypeId) === GlobalConfig.periods.rangeType) {
        var splits = committee.periodId.split(',')
        participationVm.start_date = null
        participationVm.end_date = null
        for (var i = 0; i < splits.length; i++) {
          var valor = splits[i]
          participationVm.periodsArray.push(parseInt(valor))
          participationVm.selectedTypePeriod[valor] = true
        }
      }

      if (committee.startDate) {
        var startDateNew = moment(committee.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          participationVm.minStartDate = moment(committee.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }
      participationVm.isEditing = true
    }

    function isPeriodEmpty () {
      return participationVm.periodArray.length == 0
    }

    function getNotify (origin) {
      getSendNotify(origin)
    }

    function getSendNotify (origin) {
      let msg = 'El profesor ' + listUser.dsFullname + ' ha registrado una nueva participación de comité en la etapa de planeacion.'
      if (origin == GlobalConfig.activityTypeId.originActivityExecution) {
        msg = 'El profesor ' + listUser.dsFullname + ' ha registrado una nueva participación de comité en la etapa de ejecución.'
      }
      let data = {
        idTeacher: listUser.teacherId,
        dsName: 'Notificación, se agregó o editó un comité',
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: 1,
        submodule: GlobalConfig.modules.academicManagement
      }

      console.log("--->", data)

      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data)
    }

    function addOrEditParticipation (participation) {
      participationVm.disableSaveButtom = true
      WorkPlanSrv.addActivityCommittee.add(participation).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          getNotify(participation.origin)
          confirmParticipationAction()
        } else {
          console.log('Comunications problem with server')
        }
        participationVm.disableSaveButtom = false
      }, function (data) {
        console.log(data)
      })
    }

    function addParticipation (isExecution) {
      let origin = 1
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {
      var participation = {
        teacherId: header.teacherId,
        workplanId: header.workplanId,
        committeeId: participationVm.committeeName,
        name: 'HOlA',
        description: participationVm.detail,
        hoursPlanning: participationVm.hoursPlanned,
        userId: header.teacherId,
        timeRangeTypeId: participationVm.rangeType,
        activityId: GlobalConfig.minorActivityId.participation,
        origin: origin,
        isFeedbackActivity: participationVm.isFeedback
      }

      if (participationVm.isEditing) {
        participation.workplanTeacherActivityId = header.workplanTeacherActivityId
      }

      if (parseInt(participationVm.rangeType) === participationVm.range) {
        var arrayPeriod = []
        for (var index in participationVm.periodsArray) {
          var temp = {
            periodId: participationVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        participation.periods = arrayPeriod
      } else {
        participation.startDate = new Date(participationVm.start_date)
        participation.endDate = new Date(participationVm.end_date)
      }

      // Conseguir el nombre del comite en el listado
      let aux = participationVm.listCommitteeCombo.find((comiteName) => { return comiteName.idListItem == participation.committeeId })
      participation.name = aux.listItemName
      addOrEditParticipation(participation)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!participationVm.periodsArray.includes(period.periodId)) {
          participationVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = participationVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          participationVm.periodsArray.splice(index, 1)
        }
      }
      participationVm.isTouchedPeriods = true
    }

    function confirmParticipationAction () {
      let name = getActivityNameFromCombo()
      let header = {
        createOrEdit: participationVm.createOrEditMV,
        textCreateOrEdit: participationVm.textCreateOrEdit,
        itemName: name,
        nameModal: texts.modalTypeName.comiteeParticipation,
        modalType: texts.modalTypeId.comiteeParticipation
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getActivityNameFromCombo () {
      for (var i = 0; i < participationVm.listCommitteeCombo.length; i++) {
        var row = participationVm.listCommitteeCombo[i]
        if (row.idListItem == participationVm.committeeName) {
          return participationVm.listCommitteeCombo[i].listItemName
        }
      }
    }

    function startDateChange () {
      let m = moment(participationVm.start_date)
      participationVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function close () {
      $mdDialog.hide()
    }
  }// FIN DEL CONSTRUCTOR

  rbPlanifications (bool) {
    if (bool) {
      this.start_date = null
      this.end_date = null
    } else {
      this.periodsArray = []
      this.selectedTypePeriod = null
      this.start_date = null
      this.end_date = null
    }
  }

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }

}

CreateParticipationCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', '$cookies', 'WorkPlanSrv', 'GlobalConfig', '$state', 'WorkPlanModalSrv', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/academicManagement/committeeParticipation/createParticipation/createParticipationCtrl.js